import { render, staticRenderFns } from "./AutomaticAnswersTable.vue?vue&type=template&id=270deef0&scoped=true&lang=pug"
import script from "./AutomaticAnswersTable.vue?vue&type=script&lang=js"
export * from "./AutomaticAnswersTable.vue?vue&type=script&lang=js"
import style0 from "./AutomaticAnswersTable.vue?vue&type=style&index=0&id=270deef0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "270deef0",
  null
  
)

export default component.exports